@for (id of ids(); track $index) {
  <ideal-item-result-layout [itemId]="id" />
}
